import React from "react";
import PageBanner from "./pageBanner/PageBanner";
import Content from "carbon-react/lib/components/content";

const CenteredContent = (props) => {
  return <Content align="center">{props.children}</Content>;
};

const NotFoundBanner = () => {
  return (
    <PageBanner id="page-not-found-banner" title="It doesn't exist...">
      <CenteredContent>
        Sorry, we can't find the page that you are looking for.
      </CenteredContent>
      <CenteredContent>
        This could be due to a misspelled URL or an out of date bookmark.
      </CenteredContent>
    </PageBanner>
  );
};

export default NotFoundBanner;
